export default ((context, inject) => {
  inject('logabtest', cookie => {
    var intervalAbTest = setInterval(() => {
      var cookieAbTest = context.app.$cookies.get(cookie);
      var now = Date.now();
      var endDate = new Date(cookieAbTest && cookieAbTest.slice(-10));
      if (cookieAbTest !== undefined && now <= endDate) {
        context.app.store.dispatch('abtest/setAbTestToggleState', true);
        clearInterval(intervalAbTest);
      }
      if (cookieAbTest !== undefined && now > endDate) {
        context.app.store.dispatch('abtest/setAbTestToggleState', false);
        clearInterval(intervalAbTest);
      }
    }, 500);
  });
});